import * as React from 'react';
import { Alert, Message } from '@bedrock/components';

interface showAlertProps {
  type: string;
  message: string;
  hideDelay?: number;
}

const showAlert = (props: showAlertProps) => {
  const { type = 'success', message, hideDelay = 3000 } = props;
  // 如果msg中有 \n 则替换为 <br/>
  const showMsg = message?.split?.('\n')?.map?.((item, index) => {
    return <span key={index}>{item}<br/></span>
  }) || '';
  const config = {
    content: showMsg,
    duration: hideDelay/ 1000,
    colored: true,
    style: {
      position: 'fixed',
      maxWidth: '800px',
      marginTop: '45vh',
      left: '50%',
      transform: 'translateX(-50%)',
    }
  }

  if (Message[type]) {
    Message[type](config);
  } else {
    Message.info(config);
  }
  return;
};

// 历史代码中会在全局拦截器中调用showAlert，也可能会在具体业务代码中调用showAlert
const alertCache = {};
// 加入防抖，如果在100ms内连续调用，且type和message相同，则不再弹出
const showAlertDebounce = (props: showAlertProps) => {
  const { type, message } = props;
  const key = `${type}-${message}`;
  if (alertCache[key]) {
    clearTimeout(alertCache[key]);
  }
  alertCache[key] = setTimeout(() => {
    showAlert(props);
    delete alertCache[key];
  }, 40);
}

export default showAlertDebounce;
